import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { isNullUndefined } from '@/main/services/reducerUtils';
import { AxiosResponse } from 'axios';
import { Result } from '../models/common/resultResponse';
import {
  ReportTemplateFileRequest,
  TermsOfUseFilterRequest,
  TermsOfUseGetDetailsRequest,
  TermsOfUseSaveRequest
} from '../models/request';
import {
  GetFileResponse,
  TermsOfUseDetailsResponse,
  TermsOfUseResponse
} from '../models/response';
import { FileTypeEnum } from '../services/enum/FileTypeEnum';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';
import { IFileImportApi } from './base';
import { api } from './base/api';

const baseRoute: string = 'FileImport';

export class FileImportApi extends IFileImportApi {
  getFile(
    typeFile: FileTypeEnum
  ): Promise<AxiosResponse<Result<GetFileResponse>>> {
    return api.get(`${baseRoute}/getfile/${typeFile}`, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }

  getFileReportTemplate(
    request: ReportTemplateFileRequest
  ): Promise<AxiosResponse<Result<GetFileResponse>>> {
    return api.get(`${baseRoute}/getfile/reportTemplate`, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds,
      params: request
    });
  }

  searchGridTerm(
    request: TermsOfUseFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<TermsOfUseResponse>>> {
    return api.post(`${baseRoute}/search-terms-file-import`, request);
  }

  getFileImport(
    fileImportGuid: string
  ): Promise<AxiosResponse<Result<string>>> {
    return api.get(`${baseRoute}/get-file-import`, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds,
      params: { fileImportGuid }
    });
  }

  getDetailsTerm(
    request: TermsOfUseGetDetailsRequest
  ): Promise<AxiosResponse<Result<TermsOfUseDetailsResponse>>> {
    return api.get(`${baseRoute}/detail`, { params: request });
  }
  saveTerm(
    request: TermsOfUseSaveRequest,
    file: File,
    sendFile: boolean
  ): Promise<AxiosResponse<Result<unknown>>> {
    const formData = new FormData();

    Object.entries(request).forEach(([key, value]) => {
      if (isNullUndefined(value)) return;

      if (Array.isArray(value)) {
        value.forEach(item => formData.append(key, String(item)));
      } else {
        formData.append(key, String(value));
      }
    });

    if (sendFile) {
      formData.append('formFile', file);
    }

    return api.post(`${baseRoute}/save-terms-file-import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
}
